// ROUTES
export const ROOT_PATH = '/';
export const INDEX_PATH = '/index.html';
export const LOGIN_PATH = '/login';

export const PRIVACY_PATH = '/privacy';
export const TCO_PATH = '/tco';

export const FORGOT_PASSWORD_PATH = '/password/forgot';
export const FORGOT_PASSWORD_MAIL_PATH = '/password/mail';
export const CHANGE_PASSWORD_PATH = '/password/change';
export const CHANGE_PASSWORD_SUCCESS_PATH = '/password/change/success';

export const REVIEW_SUCCESS_PATH = '/review/success';
export const REVIEW_PATH = '/review/:id';

export const EVENTS_PATH = '/events';
export const TIMETABLE_PATH = '/timetable/:id';
export const CONTRACTS_PATH = '/contracts';
export const CONTRACT_PATH = '/contracts/:id';

// ADMIN ROUTES
export const ADMIN_ROOT_PATH = '/admin';

export const ADMIN_ORGS_PATH = '/admin/organizations';
export const ADMIN_ORG_NEW_PATH = '/admin/organizations/new';
export const ADMIN_ORG_DETAILS_PATH = '/admin/organizations/:context';

export const ADMIN_EVENTS_PATH = '/admin/events';
export const ADMIN_EVENTS_NEW_PATH = '/admin/events/new';
export const ADMIN_EVENTS_DETAILS_PATH = '/admin/events/:eventId';
export const ADMIN_ORG_EVENTS_PATH = '/admin/organizations/:context/events';
export const ADMIN_ORG_EVENTS_NEW_PATH = '/admin/organizations/:context/events/new';
export const ADMIN_ORG_EVENTS_DETAILS_PATH = '/admin/organizations/:context/events/:eventId';

export const ADMIN_CONTACTS_PATH = '/admin/contacts';
export const ADMIN_CONTACTS_NEW_PATH = '/admin/contacts/new';
export const ADMIN_CONTACTS_DETAILS_PATH = '/admin/contacts/:contactId';
export const ADMIN_ORG_CONTACTS_PATH = '/admin/organizations/:context/contacts';
export const ADMIN_ORG_CONTACTS_NEW_PATH = '/admin/organizations/:context/contacts/new';
export const ADMIN_ORG_CONTACTS_DETAILS_PATH = '/admin/organizations/:context/contacts/:contactId';

export const ADMIN_PARTNERS_PATH = '/admin/partners';
export const ADMIN_PARTNERS_NEW_PATH = '/admin/partners/new';
export const ADMIN_PARTNERS_DETAILS_PATH = '/admin/partners/:partnerId';
export const ADMIN_ORG_PARTNERS_PATH = '/admin/organizations/:context/partners';
export const ADMIN_ORG_PARTNERS_NEW_PATH = '/admin/organizations/:context/partners/new';
export const ADMIN_ORG_PARTNERS_DETAILS_PATH = '/admin/organizations/:context/partners/:partnerId';

export const ADMIN_ARTISTS_PATH = '/admin/artists';
export const ADMIN_ARTISTS_NEW_PATH = '/admin/artists/new';
export const ADMIN_ARTISTS_DETAILS_PATH = '/admin/artists/:artistId';
export const ADMIN_ORG_ARTISTS_PATH = '/admin/organizations/:context/artists';
export const ADMIN_ORG_ARTISTS_NEW_PATH = '/admin/organizations/:context/artists/new';
export const ADMIN_ORG_ARTISTS_DETAILS_PATH = '/admin/organizations/:context/artists/:artistId';

export const ADMIN_CONTRACTS_PATH = '/admin/contracts';
export const ADMIN_CONTRACTS_NEW_PATH = '/admin/contracts/new';
export const ADMIN_CONTRACTS_DETAILS_PATH = '/admin/contracts/:contractId';
export const ADMIN_ORG_CONTRACTS_PATH = '/admin/organizations/:context/contracts';
export const ADMIN_ORG_CONTRACTS_NEW_PATH = '/admin/organizations/:context/contracts/new';
export const ADMIN_ORG_CONTRACTS_DETAILS_PATH = '/admin/organizations/:context/contracts/:contractId';

export const ADMIN_TEMPLATES_NEW_PATH = '/admin/contracts/templates/new';
export const ADMIN_TEMPLATES_DETAILS_PATH = '/admin/contracts/templates/:templateId';
export const ADMIN_ORG_TEMPLATES_NEW_PATH = '/admin/organizations/:context/contracts/templates/new';
export const ADMIN_ORG_TEMPLATES_DETAILS_PATH = '/admin/organizations/:context/contracts/templates/:templateId';



// WEBPACK FOOTER //
// ./src/constants/routes.js